import { c as _c } from "react/compiler-runtime";
import { BannersHeaderLayout } from "@components/page-layout/banners-header-layout";
import { DefaultBodyLayout } from "@components/page-layout/default-body-layout";
import { FullBodyLayout } from "@components/page-layout/full-body-layout";
import { AppHeader } from "@components/page-layout/header/app-header";
import { Grid } from "@mui-wrapper";
/**
 * Describes the layout for the Sphere Dashboard website.
 * Includes the header bar, the breadcrumbs and the "Outlet", in which the
 * router will inject every page content.
 *
 * To keep margins consistent across pages, every page should not have neither padding
 * nor margins for the top component, instead we define those margins and paddings here.
 *
 * @returns React main page layout component.
 */
export function MainPageLayout(t0) {
  const $ = _c(18);
  const {
    children,
    shouldHideOpenButton: t1,
    shouldShowLogo: t2,
    shouldShowUserMenu: t3,
    shouldShowSidebar: t4,
    shouldShowProgressOverviewMenu: t5,
    shouldShowBreadcrumbs: t6,
    topLeftHeaderButton,
    centerComponent,
    contentBackgroundColor,
    shouldUseFullBodyLayout: t7
  } = t0;
  const shouldHideOpenButton = t1 === undefined ? false : t1;
  const shouldShowLogo = t2 === undefined ? false : t2;
  const shouldShowUserMenu = t3 === undefined ? true : t3;
  const shouldShowSidebar = t4 === undefined ? true : t4;
  const shouldShowProgressOverviewMenu = t5 === undefined ? true : t5;
  const shouldShowBreadcrumbs = t6 === undefined ? true : t6;
  const shouldUseFullBodyLayout = t7 === undefined ? false : t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      width: "100%",
      overflow: "auto"
    };
    t9 = <BannersHeaderLayout />;
    $[0] = t8;
    $[1] = t9;
  } else {
    t8 = $[0];
    t9 = $[1];
  }
  let t10;
  if ($[2] !== centerComponent || $[3] !== shouldHideOpenButton || $[4] !== shouldShowBreadcrumbs || $[5] !== shouldShowLogo || $[6] !== shouldShowProgressOverviewMenu || $[7] !== shouldShowSidebar || $[8] !== shouldShowUserMenu || $[9] !== topLeftHeaderButton) {
    t10 = <AppHeader shouldShowLogo={shouldShowLogo} topLeftHeaderButton={topLeftHeaderButton} shouldHideOpenButton={shouldHideOpenButton} shouldShowSidebar={shouldShowSidebar} centerComponent={centerComponent} shouldShowProgressOverviewMenu={shouldShowProgressOverviewMenu} shouldShowUserMenu={shouldShowUserMenu} shouldShowBreadcrumbs={shouldShowBreadcrumbs} />;
    $[2] = centerComponent;
    $[3] = shouldHideOpenButton;
    $[4] = shouldShowBreadcrumbs;
    $[5] = shouldShowLogo;
    $[6] = shouldShowProgressOverviewMenu;
    $[7] = shouldShowSidebar;
    $[8] = shouldShowUserMenu;
    $[9] = topLeftHeaderButton;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== children || $[12] !== contentBackgroundColor || $[13] !== shouldUseFullBodyLayout) {
    t11 = shouldUseFullBodyLayout ? <FullBodyLayout>{children}</FullBodyLayout> : <DefaultBodyLayout contentBackgroundColor={contentBackgroundColor}>{children}</DefaultBodyLayout>;
    $[11] = children;
    $[12] = contentBackgroundColor;
    $[13] = shouldUseFullBodyLayout;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <Grid sx={t8}>{t9}{t10}{t11}</Grid>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}